import React, { useState } from 'react'
import * as API from '../../utility/api'

const BASE_URL = 'admin/users'
const ADMINS_URL = 'admin/users/admins'

const UserRow = ({ user }) => {
  const [loading, setLoading] = useState(false)
  const [enabled, setEnabled] = useState(user.Enabled)
  const [deleted, setDeleted] = useState(false)
  const [additionalInfo, setAdditionalInfo] = useState(null)
  const [adminSetTo, setAdminSetTo] = useState(null)

  const {
    Username,
    given_name,
    family_name,
    UserCreateDate,
    UserLastModifiedDate,
    UserStatus,
    email,
    email_verified
  } = user

  const allow_marketing = user['custom:allow_marketing'] === '1'
  const iban = user['custom:IBAN']
  const phone = user['custom:phone_number']

  const disableUser = () => {
    setLoading('disable')
    API.POST(BASE_URL, { user: Username, action: 'disable' })
      .then(() => {
        setLoading(false)
        setEnabled(!enabled)
      })
      .catch(({ response }) => {
        setLoading(false)
        console.log(response);
      })
  }

  const enableUser = () => {
    setLoading('enable')
    API.POST(BASE_URL, { user: Username, action: 'enable' })
      .then(() => {
        setLoading(false)
        setEnabled(!enabled)
      })
      .catch(({ response }) => {
        setLoading(false)
        console.log(response);
      })
  }

  const deleteUser = () => {
    const confirm = window.confirm(
      `HUOM! Käyttäjän poistamista ei voi perua. Tahdotko todella poistaa käyttäjän ${email}`
    )

    if (confirm) {
      setLoading('delete')

      API.POST(BASE_URL, { user: Username, action: 'delete' })
        .then(() => {
          setLoading(false)
          setDeleted(true)
        })
        .catch(e => {
          setLoading(false)
          console.log(e);
        })
    }
  }

  const moreInfo = () => {
    setLoading('more_info')
    API.POST(BASE_URL, { user: Username, action: 'more_info' })
      .then(({ data }) => {
        setAdditionalInfo(data)
        setLoading(false)
      })
      .catch(e => {
        setLoading(false)
        console.log(e);
      })
  }

  const checkIfAdmin = () => {
    if (adminSetTo !== null) {
      return adminSetTo
    }

    return (
      additionalInfo &&
      additionalInfo.Groups[0] &&
      additionalInfo.Groups[0].GroupName === 'admin'
    )
  }

  const toggleAdminButton = () => {
    const isAdmin = checkIfAdmin()

    return isAdmin ? (
      <button
        style={{ marginLeft: '15px', flex: 1 }}
        onClick={() => removeAdmin()}
      >
        {loading === 'admin' ? 'Muutetaan....' : 'Poista admineista'}
      </button>
    ) : (
      <button
        style={{ marginLeft: '15px', flex: 1 }}
        onClick={() => makeAdmin()}
      >
        {loading === 'admin' ? 'Muutetaan....' : 'Tee käyttäjästä admin'}
      </button>
    )
  }

  const makeAdmin = () => {
    const confirm = window.confirm(
      `Tahdotko varmasti muuttaa adminiksi käyttäjän ${email}?`
    )

    if (!confirm) {
      return
    }

    setLoading('admin')
    API.POST(ADMINS_URL, {
      action: 'add_admin',
      user: Username
    })
      .then(() => {
        setAdminSetTo(true)
        setLoading(false)
      })
      .catch(e => {
        setLoading(false)
        console.log(e);
      })
  }

  const removeAdmin = () => {
    const confirm = window.confirm(
      `Tahdotko poistaa käyttäjän ${email} admineista?`
    )

    if (!confirm) {
      return
    }

    setLoading('admin')
    API.POST(ADMINS_URL, {
      action: 'remove_admin',
      user: Username
    })
      .then(() => {
        setAdminSetTo(false)
        setLoading(false)
      })
      .catch(e => {
        setLoading(false)
        console.log(e);
      })
  }

  const smallView = (
    <div
      key={Username}
      style={{
        marginBottom: '15px',
        display: 'flex',
        flexFlow: 'column nowrap',
        border: 'solid 1px',
        padding: '15px',
        backgroundColor: 'floralwhite'
      }}
    >
      <div style={{ display: 'flex', marginLeft: '15px' }}>
        <div style={{ fontSize: 'large' }}>{given_name}</div>
        <div style={{ marginLeft: '5px', fontSize: 'large' }}>
          {family_name}
        </div>
        <div style={{ marginLeft: '15px', fontSize: 'large' }}>{email}</div>
      </div>

      <div className="break-md" />

      <div style={{ display: 'flex' }}>
        <label style={{ marginLeft: '15px', flex: 1 }}>
          <div>IBAN</div>
          {iban}
        </label>

        <label style={{ marginLeft: '15px', flex: 1 }}>
          <div>Status</div>
          {UserStatus}
        </label>

        <label style={{ marginLeft: '15px', flex: 1 }}>
          <div>user id</div>
          {Username}
        </label>
      </div>

      <div className="break-sm" />

      <div style={{ display: 'flex' }}>
        <label style={{ marginLeft: '15px', flex: 1 }}>
          <div>Puhelin</div>
          {phone}
        </label>

        <label style={{ marginLeft: '15px', flex: 1 }}>
          <div>Luotu</div>
          {UserCreateDate}
        </label>

        <label style={{ marginLeft: '15px', flex: 1 }}>
          <div>Viimeksi muokattu</div>
          {UserLastModifiedDate}
        </label>
      </div>

      <div className="break-sm" />

      <div style={{ display: 'flex' }}>
        <label style={{ marginLeft: '15px', flex: 1 }}>
          <div>Estetty</div>
          {!enabled ? 'KYLLÄ' : 'EI'}
        </label>

        <label style={{ marginLeft: '15px', flex: 1 }}>
          <div>Sähköposti varmennettu</div>
          {email_verified ? 'KYLLÄ' : 'EI'}
        </label>

        <label style={{ marginLeft: '15px', flex: 1 }}>
          <div>Markkinointi sallittu</div>
          {allow_marketing ? 'KYLLÄ' : 'EI'}
        </label>
      </div>

      <div className="break-sm" />

      {additionalInfo && (
        <div style={{ display: 'flex' }}>
          <label style={{ marginLeft: '15px', flex: 1 }}>
            <div>Admin</div>
            {checkIfAdmin() ? 'KYLLÄ' : 'EI'}
          </label>

          <label style={{ marginLeft: '15px', flex: 1 }} />

          <label style={{ marginLeft: '15px', flex: 1 }} />
        </div>
      )}

      <div className="break-md" />

      <div style={{ display: 'flex' }}>
        {!additionalInfo && (
          <button
            style={{ marginLeft: '15px', flex: 1 }}
            onClick={() => moreInfo()}
            disabled={additionalInfo}
          >
            {loading === 'more_info' ? 'Ladataan...' : 'Lisää tietoa'}
          </button>
        )}
        {additionalInfo && toggleAdminButton()}

        {enabled && (
          <button
            style={{ marginLeft: '15px', flex: 1 }}
            onClick={() => disableUser()}
          >
            {loading === 'disable' ? 'Estetään...' : 'Estä käyttäjä'}
          </button>
        )}
        {!enabled && (
          <button
            style={{ marginLeft: '15px', flex: 1 }}
            onClick={() => enableUser()}
          >
            {loading === 'enable' ? 'Palautetaan...' : 'Palauta käyttäjä'}
          </button>
        )}

        <button
          style={{ marginLeft: '15px', flex: 1 }}
          onClick={() => deleteUser()}
        >
          {loading === 'delete'
            ? 'Poistetaan käyttäjää....'
            : 'Poista käyttäjä'}
        </button>
      </div>
    </div>
  )

  if (deleted) return <div />
  return smallView
}

export default UserRow
